import Hero from "../sections/Hero";
import Showcase from "../sections/Showcase";
import Desk from "../sections/Desk";
import Stack from "../sections/Stack";
import Everything from "../sections/Everything";
import StartFree from "../sections/StartFree";
import Faq from "../sections/Faq";
import Cta from "../sections/Cta";
import StickyCta from "../ui/StickyCta";

/*
 * The order is an argument, not a list.
 *
 * What it is (hero) -> what it looks like in your hand (showcase) -> and on
 * the computer at the desk (desk) -> what you have to set up (stack) -> how
 * much of it there is (everything) -> how to start free (start-free) -> the
 * reasons you might not (faq) -> the ask (cta).
 *
 * No price on this page (owner's call, 2026-10-15: at launch the job is the
 * download). The free start sits where the price did, after the product and
 * before the objections; prices are one link away on /pricing.
 */
export default function Home() {
  return (
    <>
      <Hero />
      <Showcase />
      <Desk />
      <Stack />
      <Everything />
      <StartFree />
      <Faq />
      <Cta />
      <StickyCta />
    </>
  );
}
